import React from "react";
import { Menu, Dropdown } from "antd";

import { SearchIcon, MenuIcon } from "../../../../assets/svg";

const SearchBar = (props) => {
  const {
    handleOnChange,
    handleOnClear,
    // clearLabel,
    search,
    showClear,
  } = props;

  const searchMenu = (
    <Menu>
      <Menu.Item onClick={handleOnClear} key="0" className="red-text">
        Clear closed chats
      </Menu.Item>
    </Menu>
  );

  return (
    <div className="search-bar-container" id="search-bar-container">
      <div className="search-bar" id="search-bar">
        <div className="search-icon" id="search-icon">
          <SearchIcon />
        </div>

        <input
          className="search-input"
          id="search"
          type="text"
          name="search"
          placeholder="Search"
          value={search}
          onChange={handleOnChange}
          autoComplete="off"
        />
      </div>
      {showClear && (
        <div className="options-wrapper">
          <Dropdown
            overlayClassName="clear-chat-dropdown"
            placement="bottomRight"
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
            overlay={searchMenu}
            trigger={["click"]}
          >
            <div className="menu-icon">
              <MenuIcon />
            </div>
          </Dropdown>
        </div>
      )}
    </div>
  );
};

export default SearchBar;
